module.exports = __webpack_public_path__ + "static/media/tecnoshaft2.de5bdf59.png";